import { accountsRequestsRouteProps } from 'src/navigation/routeProps'
import { createBackgroundReducer } from 'src/redux/genericReducers'
import VirtualCardsFullPaginatedDataReducer, {
  Actions as VirtualCardsFullPaginatedDataActions,
  initialState as initialVirtualCardsFullPaginatedDataState,
  VirtualCardsFullPaginatedDataState,
} from 'src/redux/virtualCardsFullPaginatedData.reducer'

export interface AccountsRequestsState {
  virtualCardsFullPaginatedData: VirtualCardsFullPaginatedDataState
}

export const initialState: AccountsRequestsState = {
  virtualCardsFullPaginatedData: initialVirtualCardsFullPaginatedDataState,
}

export type Actions = VirtualCardsFullPaginatedDataActions

const CoreAccountsRequestsReducer = (
  state = initialState,
  action: Actions,
): AccountsRequestsState => ({
  virtualCardsFullPaginatedData: VirtualCardsFullPaginatedDataReducer(
    state.virtualCardsFullPaginatedData,
    action as VirtualCardsFullPaginatedDataActions,
  ),
})

const AccountsRequestsReducer = createBackgroundReducer(
  accountsRequestsRouteProps,
  initialState,
  CoreAccountsRequestsReducer,
)

export default AccountsRequestsReducer
